import { AxiosInstance } from 'axios';

import { BaseAuthenticatedClient } from '.';
import { BaseDataResponse, BaseResponse } from '../responses';
import { AccommodationOfferRoomTypeModel } from '../interfaces';
import { IAuthenticatedRequestHandler, IErrorHandler } from '../abstractions';

export default class AccommodationOfferRoomClient extends BaseAuthenticatedClient {
    constructor(authenticatedRequestHandler: IAuthenticatedRequestHandler, errorHandler: IErrorHandler, axiosInstance: AxiosInstance) {
        super(authenticatedRequestHandler, errorHandler, axiosInstance, 'accommodationofferroom');
    }

    public async getAllAsync(): Promise<BaseDataResponse<AccommodationOfferRoomTypeModel[]>> {
        return await this.getHttpAsync<BaseDataResponse<AccommodationOfferRoomTypeModel[]>>('', '');
    }

    public async createAsync(model: AccommodationOfferRoomTypeModel): Promise<BaseDataResponse<AccommodationOfferRoomTypeModel>> {
        return await this.postHttpAsync<BaseDataResponse<AccommodationOfferRoomTypeModel>, AccommodationOfferRoomTypeModel>('', model);
    }

    public async updateAsync(model: AccommodationOfferRoomTypeModel): Promise<BaseDataResponse<AccommodationOfferRoomTypeModel>> {
        return await this.putHttpAsync<BaseDataResponse<AccommodationOfferRoomTypeModel>, AccommodationOfferRoomTypeModel>(`${model.id}`, model);
    }

    public async deleteAsync(id: number): Promise<BaseResponse> {
        return await this.deleteHttpAsync<BaseResponse>(`${id}`);
    }
}
